import {Line, Text} from "../../utils";
import {BigCrossIcon} from "icons";
import {observer} from "mobx-react-lite";
import {useStores} from "../../stores/rootStore";
import {useL10n} from "i18n/hooks";


export const GlobalErrorBlock = observer(() => {
    const root = useStores()
    const {t} = useL10n();
    if (!root.error) return <></>

    return (
        <Line gap={24} className="error-block" justify={"space-between"}>
            <Line>
                <Text weight={500}>{root.errorMessage}</Text>
            </Line>
            <Line>
                <a onClick={() => {
                    window.location.reload()
                }}>{t('common-reload')}</a>
                <div onClick={() => root.setError(null)} className={'cross'}>
                    <BigCrossIcon/>
                </div>
            </Line>
        </Line>
    )
})
